import React from "react";
import { useHistory } from "react-router-dom";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import { TIPO_LIST } from "./TipoSelector";

const ResultadoCarga = ({ tipo, resultado, onNuevaCarga }) => {
  const history = useHistory();
  const tipoConfig = tipo ? TIPO_LIST.find((t) => t.value === tipo) : null;
  const ok = !!(resultado && resultado.Ok);
  const mensajeError =
    (resultado && (resultado.Mensaje || resultado.Error)) ||
    "El archivo no pudo ser cargado correctamente, intente de nuevo.";

  return (
    <div>
      {ok ? (
        <div className="alert alert-success">
          <i className="fas fa-check-circle me-2" />
          Archivo cargado exitosamente
          {tipoConfig && (
            <>
              {" "}
              para <strong>{tipoConfig.label}</strong>
            </>
          )}
          .
        </div>
      ) : (
        <div className="alert alert-danger">
          <i className="fas fa-exclamation-triangle me-2" />
          {mensajeError}
        </div>
      )}

      <div className="d-flex justify-content-end gap-2 mt-3">
        <AnimatedIconButton
          onClick={() => history.push("/CargaMasivaECFList")}
          iconName="view"
          message="Ver en lista"
          size="38px"
          height="22px"
          width="22px"
        />
        <AnimatedIconButton
          onClick={onNuevaCarga}
          iconName="reload"
          message="Nueva Carga"
          size="38px"
          height="22px"
          width="22px"
        />
      </div>
    </div>
  );
};

export default ResultadoCarga;
